import { render } from "./Lesson.vue?vue&type=template&id=695e266b&scoped=true&ts=true"
import script from "./Lesson.vue?vue&type=script&lang=ts"
export * from "./Lesson.vue?vue&type=script&lang=ts"

import "./Lesson.vue?vue&type=style&index=0&id=695e266b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-695e266b"]])

export default __exports__